module.exports = __webpack_public_path__ + "static/media/glow.72f1a425.gif";